import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import './filters'
import objectHash  from 'object-hash';

import { library } from '@fortawesome/fontawesome-svg-core';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { firebase } from '@firebase/app';
import "firebase/messaging"
import "firebase/analytics"

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('7d')

console.log(process.env.NODE_ENV);

firebase.initializeApp({
  apiKey              :   process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain          :   process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL         :   process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId           :   process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket       :   process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId   :   process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId               :   process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId       :   process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
});

firebase.analytics();

let messaging = null;

try{
  messaging = firebase.messaging();
  messaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_PUBLIC_VAPID);
}catch(err){
  console.log(err);
}

Vue.prototype.$firebaseMessaging = messaging;

library.add(fas, far, fab);

Vue.component('font-awesome-icon', FontAwesomeIcon);

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 900,
  easing: 'ease-in-out',
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);
import 'swiper/css/swiper.css'

import VueLodash from 'vue-lodash'

import lodash from 'lodash'
Vue.use(VueLodash, {lodash: lodash });

import vueMoment from 'vue-moment'
import 'moment/locale/ja'

Vue.use(vueMoment);

import VueTour from 'vue-tour'
Vue.use(VueTour)
// require('vue-tour/dist/vue-tour.css')

// ######## VUE APOLLO ######## //
import { ApolloClient } from 'apollo-client'
// import { createHttpLink } from 'apollo-link-http'
import { createUploadLink } from 'apollo-upload-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from '@apollo/client/link/context'

const auetpSecureKey = objectHash.MD5(new Date());

// HTTP connection to the API
const httpLink = createUploadLink({
  // You should use an absolute URL here
  uri: process.env.VUE_APP_PA_GRAPHQL_URL,
  credentials: 'include',
  headers : {
    'X-AUETP-PROTOCOL'          : 'EX-TOKEI-WTN-ERH-HTTPS',
    'X-AUETP-UPSTREAM-PROTOCOL' : 'TOKEI-MASEN-NO-542',
    'X-AUETP-SECURE-KEY'        : auetpSecureKey
  }
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('akibatrical_secure_key')

  return {
    headers: {
      ...headers,
      'X-PA-SECURE-KEY': token ? `${token}` : "",
    }
  }
})

// Cache implementation
const cache = new InMemoryCache()

// キャッシュ確認用
// setTimeout(() => {
//   console.log(cache);
// }, 10000);

// apollo cache確認用
// setInterval(() => {
//   console.dir(cache.data.data, {depth: null})
// }, 10000);

// Create the apollo client
const apolloClient = new ApolloClient({
  // credentials: 'include',
  // link: httpLink,
  link: authLink.concat(httpLink),
  cache,
})

import VueApollo from 'vue-apollo'
Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})
// ######## VUE APOLLO ######## //

//** GLOBAL MIXINS **/
import GlobalMixins                       from '@/mixins/GlobalMixins'
import RequestValidationErrorHelperMixins from '@/mixins/Request/RequestValidationErrorHelperMixins'
import ApolloClientHelperMixins           from '@/mixins/Request/ApolloClientHelperMixins'
import RestRequestResultValidationMixins  from '@/mixins/Request/RestRequestResultValidationMixins'
import AuthenticationMixins               from '@/mixins/AuthenticationMixins'

Vue.mixin(GlobalMixins);
Vue.mixin(RequestValidationErrorHelperMixins);
Vue.mixin(ApolloClientHelperMixins);
Vue.mixin(RestRequestResultValidationMixins);
Vue.mixin(AuthenticationMixins);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
